import o,{keyframes as t,css as i}from"../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as e}from"../../theme/index.js";const a=t`
from {
  opacity: 0;
}
to {
  opacity: 1;
}
`,s=t`
from {
  opacity: 1;
}
to {
  opacity: 0;
}
`,n=o.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${t=>t.theme.zIndex.overlay};
  width: 100vw;
  height: 100vh;
  background: rgba(3, 47, 74, 0.25);
  animation-fill-mode: forwards;

  ${({withAnimation:t,animationDuration:o,isClosingStarted:e})=>t&&e?i`
        animation: ${s} ${o}ms ease-out;
      `:t?i`
        animation: ${a} ${o}ms ease-out;
      `:""}
`;n.defaultProps=e;export{n as StyledOverlay};
